import { render, staticRenderFns } from "./RequestLifecycle.vue?vue&type=template&id=bb2eb12c&scoped=true&"
import script from "./RequestLifecycle.vue?vue&type=script&lang=js&"
export * from "./RequestLifecycle.vue?vue&type=script&lang=js&"
import style0 from "./RequestLifecycle.vue?vue&type=style&index=0&id=bb2eb12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2eb12c",
  null
  
)

export default component.exports